var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.043,
    height: 24.117,
    viewBox: "0 0 29.043 24.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8606",
    "data-name": "Group 8606",
    transform: "translate(-64.438 -178.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "important",
    transform: "translate(64 174.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8600",
    "data-name": "Group 8600",
    transform: "translate(0.438 3.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M20.224,4.755,7.772,25.061a1.842,1.842,0,0,0,1.57,2.8H34.7a1.842,1.842,0,0,0,1.57-2.8L23.819,4.755a2.109,2.109,0,0,0-3.6,0Z",
    transform: "translate(-7.5 -3.749)",
    fill: "#ffe177"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8601",
    "data-name": "Group 8601",
    transform: "translate(12.842 10.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M236.135,139.691l-8.707-14.2a37.4,37.4,0,0,1-3.226,9.887,38.334,38.334,0,0,1-4.435,7.116h14.8a1.841,1.841,0,0,0,1.57-2.8Z",
    transform: "translate(-219.768 -125.493)",
    fill: "#ffd15b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8602",
    "data-name": "Group 8602",
    transform: "translate(2.642 5.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M45.574,56.414a.354.354,0,0,1-.3-.539L57.349,36.18a.22.22,0,0,1,.375,0L69.8,55.874a.354.354,0,0,1-.3.539Z",
    transform: "translate(-45.22 -36.075)",
    fill: "#feb237"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8605",
    "data-name": "Group 8605",
    transform: "translate(13.838 9.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8603",
    "data-name": "Group 8603",
    transform: "translate(0 11.956)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 1.122,
    cy: 1.122,
    r: 1.122,
    fill: "#5a5a5a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8604",
    "data-name": "Group 8604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M237.929,108.806a1.122,1.122,0,0,0-1.122,1.122v7.824a1.122,1.122,0,1,0,2.243,0v-7.824A1.122,1.122,0,0,0,237.929,108.806Z",
    transform: "translate(-236.807 -108.806)",
    fill: "#5a5a5a"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.f1e02b1e095049b8cd1a4310d09035b6.svg";
export { ForwardRef as ReactComponent };